var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { greys } from "@irati/ui/src/global/colors";
export var Card = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-shadow: ", ";\n  background-color: ", ";\n  border-radius: 5px;\n  margin-top: 15px;\n  overflow: hidden;\n  img {\n    width: 100%;\n  }\n"], ["\n  box-shadow: ", ";\n  background-color: ", ";\n  border-radius: 5px;\n  margin-top: 15px;\n  overflow: hidden;\n  img {\n    width: 100%;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.shadows.mid;
}, greys.white);
export var Content = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 15px;\n"], ["\n  margin: 15px;\n"])));
var templateObject_1, templateObject_2;
